import { createFileRoute } from '@tanstack/react-router';
import messages from 'app/_authenticated/funds/messages';
import { SEO } from 'components/Seo/Seo';
import useAppLanguage from 'hooks/useAppLanguage';
import CryptoDepositView from './components/CryptoDeposit/CryptoDepositView';

export const Route = createFileRoute('/_authenticated/funds/deposit/crypto/')({
  component: CryptoDeposit,
});

function CryptoDeposit() {
  const language = useAppLanguage();

  const fundsMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={fundsMessages.title}
        description={fundsMessages.description}
        keywords={fundsMessages.keywords}
        page="/funds/deposit/crypto"
      />
      <div className="px-6 py-4">
        <CryptoDepositView />;
      </div>
    </>
  );
}
